/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './meal-schedule.reducer';

export const MealScheduleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mealScheduleEntity = useAppSelector(state => state.mealSchedule.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mealScheduleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mealSchedule.detail.title">MealSchedule</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.id">Id</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.name">Name</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.name}</dd>
          <dt>
            <span id="tmValue">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.tmValue">Tm Value</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.tmValue}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.microSec}</dd>
          <dt>
            <span id="shortCode">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.shortCode">Short Code</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.shortCode}</dd>
          <dt>
            <span id="lang">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.lang">Lang</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.lang}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.sortOrder}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mealSchedule.active">Active</Translate>
            </span>
          </dt>
          <dd>{mealScheduleEntity.active ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/meal-schedule" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/meal-schedule/${mealScheduleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MealScheduleDetail;
